/* eslint-disable max-len */
import React, {
  useEffect, useState, MouseEvent, SyntheticEvent,
  ChangeEvent, KeyboardEvent,
} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, InputBase, Box } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import posthog from 'posthog-js';

import './scss/index.scss';
import './scss/pop.scss';
import Service from '@service/index';
import Color from '@/tool/color';
import moUser from '@store/user';
import moStore from '@store/index';
import moHeader, {
  changeValue, changeJobname, getSubJob, logoutRequest, changeText,
} from './store/index';
import {
  UserVip, UserVip2, UserIcon, VipFill, AIFill,
} from '@styled/icon';
import AppAlert from '@con/app-alert';
import moSkin from '@store/skin';
import PopMarket from './pop-market';
import PopSalary from './pop-salary';
import PopUs from './pop-us';

interface IProps {
  isOpacity: boolean, // header 是否透明，默认 ture
  bgWhite?: boolean,
}
interface IState { }

const BaseButton = styled(Button)(() => ({
  height: '36px',
  borderRadius: '18px',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: 1,
}));

const VipButton = styled(Button)(() => ({
  height: '36px',
  marginRight: '10px',
  padding: '0 10px',
  color: Color.secondary,

  '&:hover': { backgroundColor: Color.secondaryColor(0) },
  '& span': {
    marginLeft: '8px',
    fontSize: '14px',
    fontWeight: 600,
  },
}));
const AiButton = styled(Button)(() => ({
  height: '28px',
  marginRight: '10px',
  padding: '0 10px',
  backgroundImage: 'linear-gradient(252deg, #00CAFF 0%, #4351C0 100%)',
  color:'#fff',
  borderRadius:'14px',
  lineHeight:'28px',
  // '&:hover': { backgroundColor: Color.secondaryColor(0) },
  '& span': {
    marginLeft: '8px',
    fontSize: '14px',
    fontWeight: 500,
  },
}));
const LoginButton = styled(Button)(() => ({
  minWidth: '30px',
  height: '36px',
  padding: '0 10px',
  margin: '0 10px',
  fontSize: '14px',
  fontWeight: 600,
  borderRadius: '3px',
  color: Color.c55,
  backgroundColor: Color.secondaryColor(0),

  '&:hover': { backgroundColor: Color.secondaryColor(0) },
  '&.primary-111': { color: Color.fff },
}));

const RegisterButton = styled(Button)(() => ({
  width: '100px',
  height: '36px',
  borderRadius: '3px',
  fontSize: '14px',
  fontWeight: 600,
  color: Color.fff,
}));

const DButton = styled(Button)(() => ({
  height: '100%',
  padding: 0,
  margin: '0 30px',
  fontWeight: 600,
  fontSize: '14px',

  '& i.go-100': {
    lineHeight: 1,
    marginLeft: '4px',
    transform: 'rotate(90deg)',
  },
  '&:hover': {
    '& i.go-100': { transform: 'rotate(270deg)' },
  },
  '&.primary-100': {
    'span': { color: Color.fff },
    '& i.go-100': { color: Color.fff },
    '& i.co-100': { color: Color.fff },
    '&:hover': { backgroundColor: Color.primaryColor(0) },
  },
  '&.opacity-100': {
    'span': { color: Color.c000 },
    '& i.go-100': { color: Color.cf },
    '&:hover': { backgroundColor: Color.primaryColor(0) },
  },
}));

const EButton = styled(Button)(() => ({
  height: '32px',
}));

const FButton = styled(Button)(() => ({
  height: '36px',
  marginRight: '10px',
}));

const HButton = styled(Button)(() => ({
  width: '120px',
  height: '36px',
  borderRadius: '18px',
  border: `1px solid ${Color.primary}`,
  color: Color.primary,
}));

const DInput = styled(InputBase)(() => ({
  border: '1px solid rgba(0, 0, 0, 0.1)',
  width: '100%',
  height: '40px',
  paddingLeft: '20px',
  margin: '10px 0 20px 0',
  borderRadius: '20px',
  background: Color.whiteColor(1),
}));

const SearchButton = styled(BaseButton)(() => ({
  height: '36px',
  width: '172px',
  borderRadius: '18px',
  color: Color.white,
}));

const DBox = styled(Box)(() => ({
  display: 'inline-flex',
  height: '100%',
}));

const Header = (props: IProps, state: IState) => {
  const location = useLocation();
  const navi = useNavigate();
  const {
    isLogin, isVip, msg, userInfo, loginHidden,
    isStructureExpired, reportCount, isExpired,
  } = moUser;
  const {
    popMarket, popSalary, popUs, userPop,
    jobname, subJobList, isAlert, alertText,
  } = moHeader;
  const { isOpacity, bgWhite } = props;
  const {
    headerHeight, partner, modules, logo1, logo2, hiddenPages,
    counselor, mainColor,
  } = moSkin;

  useEffect(() => {
    getSubJob();

    return () => { };
  }, []);

  const onHover = (ev: SyntheticEvent, text: string) => {
    ev.stopPropagation();
    if (text === 'market') {
      changeValue('popMarket', true);
      changeValue('popSalary', false);
      changeValue('popUs', false);
      changeValue('userPop', false);
    } else if (text === 'salary') {
      changeValue('popSalary', true);
      changeValue('popMarket', false);
      changeValue('popUs', false);
      changeValue('userPop', false);
    } else if (text === 'us') {
      changeValue('userPop', false);
      changeValue('popUs', true);
      changeValue('popMarket', false);
      changeValue('popSalary', false);
    } else if (text === 'user') {
      changeValue('userPop', true);
      changeValue('popMarket', false);
      changeValue('popSalary', false);
      changeValue('popUs', false);
    }
  };

  const onLeaveHeader = (ev: SyntheticEvent) => {
    ev.stopPropagation();
    changeValue('popMarket', false);
    changeValue('popSalary', false);
    changeValue('popUs', false);
    changeValue('userPop', false);
  };

  // user
  const onHoverUser = (ev: SyntheticEvent) => {
    ev.stopPropagation();
    changeValue('userPop', true);
  };

  const onLeaveUser = (ev: SyntheticEvent) => {
    ev.stopPropagation();
    changeValue('userPop', false);
  };

  const onPersonal = () => {
    window.location.href = '/personal/basic';
  };

  // 退出登录
  const onLogout = () => {
    changeValue('userPop', false);
    logoutRequest();
  };

  // 让他联系我
  const onContact = async () => {
    changeValue('userPop', false);
    if (!userInfo.phone) {
      changeValue('isAlert', true);
      changeText('您当前未绑定手机号，需绑定手机号后客服才能与您联系！');
      setTimeout(() => { changeValue('isAlert', false); }, 2000);
    } else {
      const res: any = await Service.onService();
      changeValue('isAlert', true);
      changeText(res.msg);
      setTimeout(() => { changeValue('isAlert', false); }, 2000);
    }
  };

  const onHoverRemove = (ev: SyntheticEvent) => {
    ev.stopPropagation();
    changeValue('popMarket', false);
    changeValue('popSalary', false);
    changeValue('popUs', false);
    changeValue('userPop', false);
  };

  const onVip = (ev: MouseEvent) => {
    ev.stopPropagation();
    // posthog.capture('顶部导航栏跳转-企业会员', {});
    window.location.href = '/vip';
  };

  const onLogo = (ev: MouseEvent) => {
    ev.stopPropagation();
    window.location.href = '/';
  };

  const onQuery = () => {
    // posthog.capture('顶部导航栏-职位查询', {});
    if (isEmpty(jobname)) {
      let newJob = '';
      if (!isEmpty(subJobList)) newJob = subJobList[0].job_name || '';
      else newJob = '产品经理';
      changeJobname('');
      window.location.href = '/market/result';
      localStorage.setItem('jobname', newJob);
    } else {
      changeJobname('');
      window.location.href = '/market/result';
      localStorage.setItem('jobname', jobname);
    }
  };

  const onPress = (ev: KeyboardEvent) => {
    ev.stopPropagation();
    if (ev.key === 'Enter') onQuery();
  };

  const onChange = (ev: ChangeEvent<HTMLInputElement>) => {
    ev.stopPropagation();
    changeJobname(ev.target.value);
  };

  // 登录
  const onLogin = (ev: MouseEvent) => {
    ev.stopPropagation();
    // posthog.capture('顶部导航栏登录按钮', {});
    window.location.href = `/login?url_name=${location.pathname}`;
  };

  // 注册
  const onRegister = (ev: MouseEvent) => {
    ev.stopPropagation();
    // posthog.capture('顶部导航栏注册按钮', {});
    window.location.href = '/register';
  };

  // 消息
  const onMessage = (ev: MouseEvent) => {
    ev.stopPropagation();
    // posthog.capture('顶部导航栏消息按钮', {});
    window.location.href = '/personal/system';
  };
  const onSearchAi = () => {
    posthog.capture('AI市场薪酬查询人数', {});
    window.location.href = '/chat';
  };
  // 薪酬体系设计
  const onReport = (ev: MouseEvent) => {
    ev.stopPropagation();
    posthog.capture('导航栏白皮书点击人数', {});
    window.location.href = '/home/institute';
  };

  return (
    <section onMouseLeave={(ev: SyntheticEvent) => onLeaveHeader(ev)}
      className={[
        'header-comp',
        isOpacity ? 'opacity-header' : (partner === 'smartsalary' ? 'primary-header' : 'white-header'),
      ].join(' ')}
      style={{ height: `${headerHeight}px` }}>
      <section className="header-container">
        <section className="header-left">
          {(isOpacity || partner !== 'smartsalary') ? (
            <img src={logo1} alt="logo" aria-hidden="true" onClick={onLogo} />
          ) : (
            <img src={logo2} alt="logo" aria-hidden="true" onClick={onLogo} />
          )}
        </section>

        <section className="header-menu">
          <section className="menu-100">
            {modules.includes('marketData') ? (
              <DButton className={[
                (isOpacity || partner !== 'smartsalary') ? 'opacity-100' : 'primary-100',
              ].join(' ')}
              onMouseEnter={(ev: SyntheticEvent) => onHover(ev, 'market')}>
                <span>市场人才数据</span>
                <i className="iconfont icon-go go-100" />
              </DButton>
            ) : null}
            {modules.includes('salaryTool') ? (
              <DButton className={[
                (isOpacity || partner !== 'smartsalary') ? 'opacity-100' : 'primary-100',
              ].join(' ')}
              onMouseEnter={(ev: SyntheticEvent) => onHover(ev, 'salary')}>
                <span>薪酬方案工具</span>
                <i className="iconfont icon-go go-100" />
              </DButton>
            ) : null}
            {modules.includes('industryReport') ? (
              <DButton className={[
                (isOpacity || partner !== 'smartsalary') ? 'opacity-100' : 'primary-100',
              ].join(' ')}
              onMouseEnter={(ev: SyntheticEvent) => onHoverRemove(ev)}
              onClick={(ev: MouseEvent) => onReport(ev)}>
                <span>行业报告/白皮书</span>
              </DButton>
            ) : null}
            {modules.includes('aboutUs') ? (
              <DButton className={[
                (isOpacity || partner !== 'smartsalary') ? 'opacity-100' : 'primary-100',
              ].join(' ')}
              onMouseEnter={(ev: SyntheticEvent) => onHover(ev, 'us')}>
                <span>关于我们</span>
                <i className="iconfont icon-go go-100" />
              </DButton>
            ) : null}
          </section>
        </section>

        <section className="header-right">
          {!isLogin ? (
            <section className={['right-90 right-91'].join(' ')}>
              {modules.includes('aisearch') ? <AiButton>
                <AIFill color='#fff'/>
                <span onClick={onSearchAi}>AI 助手</span>
              </AiButton> : null}
              {modules.includes('price') ? (
                <VipButton onClick={(ev: MouseEvent) => onVip(ev)}
                  onMouseEnter={(ev: SyntheticEvent) => onHoverRemove(ev)}>
                  <VipFill color={Color.secondary} />
                  <span>企业套餐</span>
                </VipButton>
              ) : null}
              <section className={[
                'line-910', loginHidden ? 'hidden' : 'visible',
              ].join(' ')}>
                <span className="line-1110" />
                <LoginButton onClick={(ev: MouseEvent) => onLogin(ev)}
                  className={[
                    (isOpacity || partner !== 'smartsalary') ? '' : 'primary-111',
                  ].join(' ')}>登录
                </LoginButton>
                {modules.includes('register') ? (
                  <RegisterButton onClick={(ev: MouseEvent) => onRegister(ev)}
                    style={{
                      backgroundColor: partner === 'smartsalary' ? Color.secondary : mainColor,
                    }}>注册有礼
                  </RegisterButton>
                ) : null}
              </section>
            </section>
          ) : (
            <section className={['right-90 right-92'].join(' ')}>
              {modules.includes('aisearch') ? <AiButton>
                <AIFill color='#fff'/>
                <span onClick={onSearchAi}>AI 助手</span>
              </AiButton> : null}
              {modules.includes('price') ? (
                <VipButton onClick={(ev: MouseEvent) => onVip(ev)}
                  onMouseEnter={(ev: SyntheticEvent) => onHoverRemove(ev)}>
                  <VipFill color={Color.secondary} />
                  <span>企业套餐</span>
                </VipButton>
              ) : null}
              <span className="line-1110" style={{ marginRight: '10px' }} />
              <section className={['line-910'].join(' ')}>
                <p className="message-30" aria-hidden="true"
                  onMouseEnter={(ev: SyntheticEvent) => onHoverRemove(ev)}
                  onClick={(ev: MouseEvent) => onMessage(ev)}>
                  <i className={[
                    'iconfont', 'icon-pinglun', 'message-11',
                    (isOpacity || partner !== 'smartsalary') ? 'black-55' : 'white-55',
                  ].join(' ')} />
                  {msg ? <sup>{msg}</sup> : null}
                </p>
                <p className="user-30" aria-hidden="true"
                  onMouseEnter={(ev: SyntheticEvent) => onHover(ev, 'user')}>
                  {!isVip ? (
                    <i className="iconfont icon-iconheaderuserFFFFFF1"
                      style={{
                        color: isOpacity ? Color.blackColor(1) : Color.fff,
                        fontSize: '24px',
                      }} />
                  ) : null}
                  {(isVip && isOpacity) ? (
                    <UserVip2 width={26} height={26} color={Color.secondary} />
                  ) : null}
                  {(isVip && !isOpacity) ? (
                    <UserVip width={26} height={26} color={Color.secondary} />
                  ) : null}
                </p>
              </section>
            </section>
          )}
        </section>
      </section>

      {/** 市场人才数据 */}
      {popMarket ? <PopMarket /> : null}

      {/** 薪酬方案工具 */}
      {popSalary ? <PopSalary /> : null}

      {/** 关于我们 */}
      {popUs ? <PopUs /> : null}

      {userPop ? (
        <section className="user-pop_50"
          style={{ top: `${headerHeight}px` }}>
          <section className="user-pop_51">
            <section className="user-pop_015"
              onMouseEnter={(ev: SyntheticEvent) => onHoverUser(ev)}
              onMouseLeave={(ev: SyntheticEvent) => onLeaveUser(ev)}>
              <section className="user-016">
                <section className="user-017" aria-hidden="true" onClick={onPersonal}>
                  <i className="iconfont icon-useradmin logo-0020" />
                  <p className="line-018">
                    <b>{userInfo?.email}</b><span>{userInfo?.company}</span>
                  </p>
                </section>
                <p className="line-017">
                  <FButton onClick={onPersonal}>账号管理</FButton>
                  <FButton onClick={onLogout}>退出</FButton>
                </p>
                <section className="service-017">
                  <b>我的专属客服</b>
                  <section className="service-018">
                    <p className="logo-0010">
                      <img src={userInfo.saleInfo.photo} alt="" />
                    </p>
                    <p className="contact-0010">
                      <span className="text11">
                        客服：{userInfo.saleInfo.name}
                      </span>
                      <span className="text11">
                        电话：{userInfo.saleInfo.phone}
                      </span>
                      <span className="text11">
                        邮箱：{userInfo.saleInfo.email}
                      </span>
                    </p>
                  </section>
                  <p className="line-019">
                    <HButton onClick={onContact}>让他联系我</HButton>
                  </p>
                </section>
              </section>
            </section>
          </section>
        </section>
      ) : null}

      {isAlert ? <AppAlert text={alertText} /> : null}
    </section>
  );
};

export default observer(Header);
